import { ListingStatusType } from '../types';

export class GtmStatsAdapterListingStatus {
  /**
   * Mapping from listingStatus to ListingStatusType
   */
  protected mapping: { [key: string]: ListingStatusType } = {
    standard: 'Standard',
    featured: 'Featured',
    premium: 'Premium',
    smart_ad: 'SmartAd',
    cts: 'CommunityTopSpot',
    direct_from_developer_featured: 'Direct from developer - featured',
    direct_from_developer_premium: 'Direct from developer - premium',
  };

  /**
   * Exclusive text
   */
  private exclusiveText: string = 'Exclusive';

  /**
   *
   * @param listingStatusDisplayed
   */
  constructor(protected listingStatusDisplayed: string, protected isExclusive: boolean = false) {}

  /**
   * Returns a listingLevel string transformed into a ListingStatusType
   */
  public getData(): ListingStatusType {
    // Returns the mapped value or falls back to the original value
    let listingStatus = this.mapping[this.listingStatusDisplayed] || this.listingStatusDisplayed;
    listingStatus += this.isExclusive ? ` - ${this.exclusiveText}` : '';

    return listingStatus;
  }
}
